'use client'

import { useCookiesContext } from 'cookies/hooks/useCookiesContext/useCookiesContext'
import { useEffect, useRef } from 'react'
import { env } from 'utils/envManager/envManager'

export function GoogleTagManager(): React.ReactNode {
	const { cookiesConsent } = useCookiesContext()
	const loadedRef = useRef(false)

	useEffect(() => {
		if (!loadedRef.current && typeof cookiesConsent === 'boolean') {
			loadedRef.current = true

			const script = document.createElement('script')
			script.src = `${env.NEXT_PUBLIC_GTM_SERVER_SIDE}/gtm.js?id=GTM-W5MKJLK`
			script.async = true

			document.body.appendChild(script)
		}
	}, [cookiesConsent])

	return null
}
